import api from './api';
import type {
  DashboardInventarioDto,
  DisponibilidadDto,
  ImportResultDto,
  InventoryItemRefDto,
  KardexEntryDto,
  StockRowDto,
  TipoItem,
} from '@/types/inventario';

export interface StockFilters {
  almacenId?: number | null;
  itemType?: TipoItem | null;
  q?: string | null;
}

export const inventarioApi = {
  dashboard: () =>
    api.get<DashboardInventarioDto>('/inventario/dashboard').then((r) => r.data),

  stock: (filters: StockFilters = {}) => {
    const params: Record<string, string | number> = {};
    if (filters.almacenId != null) params.almacenId = filters.almacenId;
    if (filters.itemType) params.itemType = filters.itemType;
    if (filters.q && filters.q.trim()) params.q = filters.q.trim();
    return api
      .get<StockRowDto[]>('/inventario/stock', { params })
      .then((r) => r.data);
  },

  kardex: (inventoryItemId: number) =>
    api
      .get<KardexEntryDto[]>(`/inventario/kardex/${inventoryItemId}`)
      .then((r) => r.data),

  searchItems: (q: string, itemType: TipoItem | null = null, limit = 20) => {
    const params: Record<string, string | number> = { limit };
    if (q && q.trim()) params.q = q.trim();
    if (itemType) params.itemType = itemType;
    return api
      .get<InventoryItemRefDto[]>('/inventario/items/search', { params })
      .then((r) => r.data);
  },

  disponibilidad: (itemType: TipoItem) =>
    api
      .get<DisponibilidadDto[]>('/inventario/disponibilidad', { params: { itemType } })
      .then((r) => r.data),

  /** Descarga el .xlsx como Blob para guardarlo en disco. */
  downloadTemplate: () =>
    api
      .get('/inventario/import/template', { responseType: 'blob' })
      .then((r) => r.data as Blob),

  uploadFile: (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    return api
      .post<ImportResultDto>('/inventario/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((r) => r.data);
  },
};
